export default __webpack_public_path__ + "static/media/logo.3a41e4a2.png";